import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

import { withLoader } from '../thunkWrappers';

export const resendRegistrationOtpThunk = createAppAsyncThunk<
  undefined,
  { username: string },
  { rejectValue: { message: string } }
>(
  'auth/resendRegistrationOtp',
        withLoader(

  async(params, { extra: { authService }, rejectWithValue }) => {
    try {
      await authService.resendRegistrationOtp(params);
      return undefined;
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to resend registration OTP';
      return rejectWithValue({ message });
    }
      })
);
